/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-06-24 10:59:11
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-24 10:54:00
 */
// 运行时配置

import GlobalHeaderRight from '@/components/RightContent';
import { getCurrentUser } from '@/services/currentUser';
import { PageContainer } from '@ant-design/pro-components';
import {
  history,
  type RequestConfig,
  type RunTimeLayoutConfig,
} from '@umijs/max';
import { message as Message, notification } from 'antd';
import { stringify } from 'querystring';
import { LOGIN_URL } from './constants';
import './global.scss';
// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate

export async function getInitialState(): Promise<{
  currentUser?: any;
  loading?: boolean;
  fetchUserInfo?: () => Promise<any>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await getCurrentUser();
      return msg.data;
    } catch (error) {
      // history.push(loginPath);
      const { search, pathname } = history.location;
      history.push({
        pathname: LOGIN_URL,
        search: stringify({
          redirect: pathname + search,
        }),
      });
    }
    return undefined;
  };

  if (location?.pathname !== LOGIN_URL) {
    const userInfo = await fetchUserInfo();

    return {
      fetchUserInfo,
      currentUser: userInfo,
    };
  } else {
    return {
      fetchUserInfo,
    };
  }
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  const token = localStorage.getItem('Authorization');
  const { currentUser } = initialState || {};
  const navigate = (path: string) => {
    history.replace(path);
  };

  /** 判断用户当前用户所属路径 */
  if (location?.pathname === '/' || location?.pathname === '/home') {
    // 跳转admin页面
    switch (currentUser?.roleName) {
      case 'admin':
        navigate('/user');
        break;
      case 'factory':
        navigate('/factory/normal');
        break;
      case 'operation':
        navigate('/order/normal');
        break;
      case 'supplier':
        navigate('/quality');
        break;
      case 'finance':
        navigate('/finance/factory');
        break;
      default:
        navigate('/login');
    }
  }
  if (!token) {
    navigate('/login');
  }
  /** 判断是否有token */
  return {
    // title: '内部电商工具',
    title: false,
    logo: false,
    // logo: 'https://img.alicdn.com/tfs/TB1YHEpwUT1gK0jSZFhXXaAtVXa-28-27.svg',
    menu: {
      locale: false,
    },
    layout: 'mix',
    menuExtraRender: () => <p></p>,
    headerContentRender: () => {
      return <GlobalHeaderRight />;
    },

    // rightRender: () => {
    //   return <GlobalHeaderRight />;
    // },
    contentWidth: 'fixed',
    // fixedHeader: true,
    childrenRender: (children) => {
      return (
        <PageContainer
          style={{
            paddingBlockStart: 48,
          }}
        >
          {children}
        </PageContainer>
      );
    },
  };
};

enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}

interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

export const request: () => RequestConfig = () => {
  return {
    timeout: 300000,
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    paramsSerializer(params) {
      return stringify(params);
    },
    // other axios options you want
    errorConfig: {
      errorHandler(error: any, options: any) {
        if (options?.skipErrorHandler) throw error;
        const { response = {}, message } = error;
        const { status = null } = response;
        if (String(response) !== '{}' && response.status) {
          const errorText = response.statusText;
          const msg = response.data.message || message;
          // 401时回到登录页面
          if (status === 401) {
            notification.warn({
              message: '您未登录或登录信息已过期，请重新登录!',
            });
            // 清除token
            // MoveTokenFromLocalStorage();
            // ...跳转到登录页面。
            // history.push(loginPath)
            const { search, pathname } = history.location;
            history.replace({
              pathname: loginPath,
              search: stringify({
                redirect: pathname + search,
              }),
            });
          } else {
            notification.error({
              message: `请求错误 [${status}]: ${msg}`,
              description: errorText,
            });
          }
        } else if (String(response) === '{}') {
          notification.error({
            description: message || '您的网络发生异常，无法连接服务器',
            message: message || '网络异常',
          });
        } else {
          notification.error({
            description: message || '您的网络发生异常，无法连接服务器',
            message: message || '网络异常',
          });
        }
        error.response = {
          message: error.message,
        };
        Message.destroy();
        return Promise.reject(error);
      },

      errorThrower: (res: ResponseStructure) => {
        const { success, data, errorCode, errorMessage, showType } = res;
        if (!success) {
          const error: any = new Error(errorMessage);
          error.name = 'BizError';
          error.info = { errorCode, errorMessage, showType, data };
          throw error; // 抛出自制的错误
        }
      },
    },
    requestInterceptors: [
      (url, options) => {
        // const { initialState, loading, refresh, setInitialState } =
        //   useModel('@@initialState');
        return {
          url,
          options: {
            ...options,
            headers: {
              ...options.headers,
              Authorization: localStorage.getItem('Authorization'),
            },
          },
        };
      },
    ],
    responseInterceptors: [
      (response: any) => {
        const { data = {} }: { url: string; status: number; data: any } =
          response;

        const { code, message } = data;
        /** 接口请求成功，做错误拦截 */
        if (code < 200 || code > 300) {
          notification.info({
            message: message,
            description: data.data,
          });
          return {
            data: {
              success: true,
              message: message,
              code: code,
            },
          };
        }
        return response;
      },
    ],
  };
};
